import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Commercial, User } from '@shared/models';
import { BehaviorSubject } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from './user.service';

@Injectable()
export class CommercialService {

  private isCommercial: BehaviorSubject<Commercial> = new BehaviorSubject(new Commercial(false, false, false));

  private userSubscription: Subscription;
  private user: User;

  constructor(private _userService: UserService) {
    this.userSubscription = this._userService.getUser().subscribe(user => {
      this.user = user;
      this.setCommercial();
    });

  }


  public setCommercial() {
    let commercialBool = window.location.hostname.toLowerCase().indexOf('commercial') >= 0;
    let customerBool = this.setCustomerCommercialValue();
    let accountBool = this.setAccountCommercialValue();
    this.isCommercial.next(new Commercial(commercialBool, customerBool, accountBool));
    return commercialBool;
  }

  public getCommercialValue(): Observable<Commercial> {
    return new Observable(fn => this.isCommercial.subscribe(fn));
  }

  setCustomerCommercialValue() {
    let customerCommercialBool = false;
    if (this.user.accountSummaryArray)
      for (let account of this.user.accountSummaryArray) {
        if (account.ProgramType === 18 || account.ProgramType === 19 || account.ProgramType === 15 || account.ProgramType === 17) {
          customerCommercialBool = true;
          break;
        }
      }
    return customerCommercialBool;

  }

  setAccountCommercialValue() {
    let accountCommercialBool = false;
    if (this.user.accountSummaryArray) {
      if (this.user.accountSummaryArray.length > 0) {
        let account = this.user.accountSummaryArray[this.user.accountIndex];
        if (account.ProgramType === 18 || account.ProgramType === 19) {
          accountCommercialBool = true;
        }
      }
    }
    return accountCommercialBool;
  }

  setAccountCommercialByInput(programType) {
    if (programType === 18 || programType === 19) {
      this.isCommercial.next(new Commercial(this.isCommercial.value.isCommercialDomain, this.isCommercial.value.isCustomerCommercial, true));
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/services/commercial.service.ts